<script lang="ts">
	// @ts-nocheck

	import { page } from '$app/stores';

	interface Props {
		title?: string;
		description?: string;
		keywords?: string;
		canonical?: any;
		siteName?: string;
		imageURL?: string;
		logo?: string;
		author?: string;
		type?: string;
		name?: string;
		index?: boolean;
		twitter?: boolean;
		openGraph?: boolean;
		schemaOrg?: boolean;
		socials?: any;
		children?: import('svelte').Snippet;
	}

	let {
		title = '',
		description = '',
		keywords = '',
		canonical = $page.url,
		siteName = 'Tassie Tours',
		imageURL = '$lib/assets/images/hero-carousel-1.jpg',
		logo = '$lib/assets/logo/logo-black.png',
		author = 'Tassie Tours',
		type = 'website',
		name = 'Tassie Tours',
		index = true,
		twitter = true,
		openGraph = true,
		schemaOrg = false,
		socials = [],
		children
	}: Props = $props();

	let Ld = {
		'@context': 'https://schema.org',
		'@type': `${type}`,
		name: `${name}`,
		url: `${$page.url.origin}`,
		image: `${imageURL}`,
		author: {
			'@type': 'Person',
			name: `${author}`
		},
		publisher: {
			'@type': 'Organization',
			name: `${siteName}`,
			logo: {
				'@type': 'ImageObject',
				url: `${logo}`,
				width: 48,
				height: 48
			}
		},
		sameAs: [`${socials.join(', ')}`]
	};
	let jsonLdScript = `<script type="application/ld+json">${JSON.stringify(Ld)}${'<'}/script>`;
</script>

<svelte:head>
	{#if title !== ''}
		<meta name="robots" content={index ? 'index, follow' : 'noindex'} />
		<title>{title}</title>
		<meta rel="canonical" href={canonical === '' ? $page.url : canonical} />
	{/if}
	{#if description !== ''}
		<meta name="description" content={description} />
	{/if}
	{#if keywords !== ''}
		<meta name="keywords" content={keywords} />
	{/if}
	{#if author !== ''}
		<meta name="author" content={author} />
	{/if}
	{#if openGraph}
		{#if siteName !== ''}
			<meta property="og:site_name" content={siteName} />
		{/if}
		{#if title !== ''}
			<meta property="og:url" content={$page.url} />
			<meta property="og:type" content={type} />
			<meta property="og:title" content={title} />
		{/if}
		{#if description !== ''}
			<meta property="og:description" content={description} />
		{/if}
		{#if imageURL !== ''}
			<meta property="og:image" content={imageURL} />
		{/if}
	{/if}
	{#if twitter}
		{#if title !== ''}
			<meta name="twitter:card" content="summary_large_image" />
			<meta property="twitter:domain" content={$page.url.host} />
			<meta property="twitter:url" content={$page.url} />
			<meta name="twitter:title" content={title} />
		{/if}
		{#if description !== ''}
			<meta name="twitter:description" content={description} />
		{/if}
		{#if imageURL !== ''}
			<meta name="twitter:image" content={imageURL} />
		{/if}
	{/if}
	{@render children?.()}
	{#if schemaOrg || socials[0] !== undefined || logo !== '' || name !== ''}
		{@html jsonLdScript}
	{/if}
</svelte:head>
